



























































import { Component, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import DialogDetail2 from '@/views/dataView/ziYangDataViewBlack/unit/dialog/box2/dialogDetail2.vue';

@Component({
  components: { DialogDetail2 },
})
export default class ViewHazardList extends Vue {
  private dialogVisible = false;
  private tableData: any = [];
  private showDialog(rowId: any) {
    this.getData(rowId);
    this.dialogVisible = true;
  }
  private getData(id: any) {
    zyScreenServer.getViewHazardManageList(id).then((res: any) => {
      if (res.code === '200') {
        this.tableData = res.data;
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
  showDetail(item: any) {
    const refName = 'DialogDetail2Ref';
    const dialog = this.$refs[refName];
    (dialog as any).showDialog(item);
  }

  handleClose(done: any) {
    done();
  }
}
